import { render } from "./DeliveryScreen.vue?vue&type=template&id=9fc63c3e"
import script from "./DeliveryScreen.vue?vue&type=script&lang=js"
export * from "./DeliveryScreen.vue?vue&type=script&lang=js"
script.render = render

export default script